export default __webpack_public_path__ + "static/media/cms.2b6d94e4.PNG";